import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import {
  SOFTLINE_PERMISSION_KOMMISSIONIERUNG,
  SOFTLINE_PERMISSION_VORKOMMISSIONIERUNG,
} from './kommissionierung.shared';
import { KommissionierungService } from './services/kommissionierung.service';
import { KommissionsauftragKopf } from './types/kommissionsauftrag';

export const kommissionierungRoutes: Routes = [
  {
    path: 'kommissionierung',
    children: [
      {
        path: 'filter',
        loadComponent: () =>
          import('./pages/filter/filter.page').then((o) => o.FilterPage),
      },
      {
        path: ':idkopfkomm/abschluss',
        loadComponent: () =>
          import('./pages/abschluss/abschluss.page').then((o) => o.AbschlussPage),
      },
      {
        path: ':idkopfkomm/:idbewekomm',
        loadComponent: () =>
          import('./pages/artikel-menge/artikel-menge.page').then(
            (o) => o.ArtikelMengePage
          ),
      },
      {
        path: ':idkopfkomm',
        loadComponent: () =>
          import('./pages/auftrag-artikel/auftrag-artikel.page').then(
            (o) => o.AuftragArtikelPage
          ),
      },
      {
        path: 'mischpalette/:idkopfkomm/:sscc',
        loadComponent: () =>
          import('./pages/mischpalette-detail/mischpalette-detail.component'),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/auftrag-auswahl/auftrag-auswahl.page').then(
            (o) => o.AuftragAuswahlPage
          ),
        data: {
          filterFn: (order: KommissionsauftragKopf) => !order?.mischpalette,
        },
      },
      { path: '**', redirectTo: '/kommissionierung' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_KOMMISSIONIERUNG },
  },
];

export const vorKommissionierungRoutes: Routes = [
  {
    path: 'vorkommissionierung',
    children: [
      {
        path: 'filter',
        loadComponent: () =>
          import('./pages/filter/filter.page').then((o) => o.FilterPage),
      },
      {
        path: ':idkopfkomm/abschluss',
        loadComponent: () =>
          import('./pages/abschluss/abschluss.page').then((o) => o.AbschlussPage),
      },
      {
        path: ':idkopfkomm/:idbewekomm',
        loadComponent: () =>
          import('./pages/artikel-menge/artikel-menge.page').then(
            (o) => o.ArtikelMengePage
          ),
      },
      {
        path: ':idkopfkomm',
        loadComponent: () =>
          import('./pages/auftrag-artikel/auftrag-artikel.page').then(
            (o) => o.AuftragArtikelPage
          ),
      },
      {
        path: 'mischpalette/:idkopfkomm/:sscc',
        loadComponent: () =>
          import('./pages/mischpalette-detail/mischpalette-detail.component'),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/auftrag-auswahl/auftrag-auswahl.page').then(
            (o) => o.AuftragAuswahlPage
          ),
        data: {
          filterFn: (order: KommissionsauftragKopf) => order?.mischpalette === true,
        },
      },
      { path: '**', redirectTo: '/vorkommissionierung' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {
      title: 'Vor-Kommissionierung',
      permission: SOFTLINE_PERMISSION_VORKOMMISSIONIERUNG,
    },
  },
];
